import NotificationTable from "../../modules/notification/NotificationTable";

export const NotificationPage = () => {
  return (
    <NotificationTable/>
  );
};
